import { FC, useMemo } from "react";
import StarRateNewTrustScore from "../../../components/StarRate2.0";
import { scoreToDisplayStars } from "../../../config/rating";
import { IWidgetTemplate } from "../../../interfaces/widget-template";
import { ReachClick } from "../../../utils/core";
import { resolveWidgetV2Style } from "./widgetV2Styles";

/** Stars Row (v2) — admin-preview-only. Real embed markup lives in widget-v2.js (renderStars). */
const WidgetTemplate17: FC<IWidgetTemplate> = ({ company, score, style }) => {
  const companyId = company?.companyId;
  const resolvedStyle = resolveWidgetV2Style("stars", style);
  const payload = useMemo(() => ({ companyId, widgetId: 17 as const }), [companyId]);
  const profileUrl = useMemo(
    () => `https://www.trustfinance.com/companies/${companyId}?utm_source=widget&utm_medium=dom&utm_campaign=widget-v2-stars`,
    [companyId],
  );
  const starsValue = scoreToDisplayStars(score?.score ?? 0);

  return (
    <div className="d-flex justify-content-center">
      <a
        href={profileUrl}
        target="_blank"
        rel="noopener"
        onClick={() => ReachClick(payload)}
        className="d-flex align-items-center gap-1"
        style={{ textDecoration: "none", color: "#1c1c2e" }}
      >
        <StarRateNewTrustScore value={score?.score} size={18} />
        {resolvedStyle === "with-count" && (
          <span style={{ fontSize: 11.5, color: "#6b6b85", marginLeft: 4 }}>({(score?.totalReview ?? 0).toLocaleString()})</span>
        )}
        {resolvedStyle === "with-score" && <b style={{ fontSize: 13, marginLeft: 4 }}>{starsValue}</b>}
      </a>
    </div>
  );
};

export default WidgetTemplate17;
